import React, { useCallback } from 'react'
import { Button, Form, RenderFields } from 'components/Form'
import { registerHooks } from '.'
import { Logo } from '../Style'
import { GridStep1, SchoolRegistrationStyles, SchoolStep, StepTitle, WrapStepFields } from './Style'
import { Go1 } from 'assets'
import { Space } from 'styles/GlobalStyle'
import { useMutation } from '@tanstack/react-query'
import { registerSchoolFetch } from 'store/middlewares/user.crud'
import { useSelector } from 'react-redux'
import { schoolFormValidate } from './Validate'
import { ReactComponent as LogoIcon } from 'assets/LogoGo.svg';
import { isValid, submit } from 'redux-form'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { useDispatch } from 'react-redux'
import AuthWithCartoon from '../AuthWithCartoon'
import { Title } from 'components/Form/Styled'
import { CreateTicketFab } from 'pages/CreateTicket'
import { SvgIcon } from '@mui/material'

const SchoolRegistration = () => {
    const { personalFields, schoolFields } = registerHooks.useSchoolFields()
    const formValues = useSelector(state => state.form.schoolRegistration?.values)
    const isFormValid = useSelector(state => isValid('schoolRegistration')(state));
    const dispatch = useDispatch()

    const { mutateAsync: registerSchool, isPending } = useMutation({
        mutationFn: registerSchoolFetch,
        onSuccess: () => {
            toast("הטופס נשלח בהצלחה", toastConfig)
        }
    })

    const postMessage = useCallback(() => {
        if (!isFormValid) {
            dispatch(submit('schoolRegistration'))
            return false
        }
        const registerData = {
            ...formValues,
            role: formValues.role.name
        }
        registerSchool(registerData)
    }, [formValues, isFormValid])

    return (
        <SchoolRegistrationStyles>
            <Logo>
                <SvgIcon component={LogoIcon} color="black" inheritViewBox />
            </Logo>
            <AuthWithCartoon cartoon={Go1}>
                <Form
                    form={"schoolRegistration"}
                    title={null}
                    validations={schoolFormValidate}
                    submitBtns={[]}
                    submit={() => { }}
                >
                    <div className='school-fields'>
                        <Title className='school-step-title'>{"פרטים אישיים"}</Title>
                        <SchoolStep>
                            <RenderFields fields={personalFields} />
                        </SchoolStep>
                        <Space />
                        <Title className='school-step-title'>{"פרטי בית הספר"}</Title>
                        <SchoolStep>
                            <RenderFields fields={schoolFields} />
                        </SchoolStep>
                        <SchoolStep>
                            <div className='submit-btn'>
                                <Button
                                    variant="regular2"
                                    label="שליחה"
                                    color="thirdly"
                                    action={postMessage}
                                    loading={isPending}
                                />
                            </div>
                        </SchoolStep>
                    </div>
                </Form>
            </AuthWithCartoon>
            <CreateTicketFab />
        </SchoolRegistrationStyles>
    )
}

export default SchoolRegistration